import { ConnectError } from '@bufbuild/connect';
import { createAsyncThunk, DeepPartial } from '@reduxjs/toolkit';

import api from '@/shared/api/api';
import { Notifications } from '@/shared/api/protocol-ts/api/notifications/svc_notifications_connectweb';
import {
  NotificationsStreamReq,
  NotificationsMarkAsReadReq,
  RegisterPushSubscriptionReq,
} from '@/shared/api/protocol-ts/api/notifications/svc_notifications_pb';

type NotificationRequests = keyof typeof Notifications.methods;

const requestGenerator = <Req>(requestName: NotificationRequests) =>
  createAsyncThunk(
    `notification/${requestName}`,
    async (request: DeepPartial<Req>, { rejectWithValue }) => {
      try {
        const response = await api.notifications[requestName](request);

        return response;
      } catch (error) {
        const connectError = ConnectError.from(error);
        return rejectWithValue(connectError);
      }
    },
  );

export const notificationsStream =
  requestGenerator<NotificationsStreamReq>('stream');

export const notificationsMarkAsRead =
  requestGenerator<NotificationsMarkAsReadReq>('markAsRead');

export const registerPushSubscription =
  requestGenerator<RegisterPushSubscriptionReq>('registerPushSubscription');
